export const CAROUSEL_ID =
  process.env.ENVIRONMENT !== "development"
    ? "729fd8a1-e642-4c48-bcab-7bbfe2c27eb3"
    : "220bb7a8-82b9-4bfe-b006-9373994b4e8a"
export const HOMEPAGE_ID =
  process.env.ENVIRONMENT !== "development"
    ? "a23773c2-ec5a-4f67-99f5-ae70b283d915"
    : "dc88fd64-5f39-4248-8d92-6b1086ba55ff"
